import {Box,Tabs,Tab} from '@mui/material';

const PageDetailTabs=({pageTabs,pageTab,application,handleChangeTab,rowId,row,userData,entityType,pageTabCallback,refreshToken})=>{
    //pageTab can briefly point past the end when tabs get hidden after the record loads - render nothing until it's re-synced
    const TabComponent=pageTabs[pageTab]?.component;
    return <>
        {Object.keys(pageTabs).length!==0&&TabComponent&&
        <Box sx={{bgcolor:'none'}}>
            <Tabs
                value={pageTab}
                onChange={handleChangeTab}
                sx={{
                    "& button:hover":{backgroundColor:'lightgrey'},
                    "& button:focus":{backgroundColor:'white'},
                    "& .MuiTab-root.Mui-selected":{backgroundColor:'white'},
                    "& .MuiTab-root":{
                        minHeight:'35px',
                        paddingY:0.5,
                        fontSize:'0.85rem',
                    },
                    minHeight:'35px',
                }}
                variant="scrollable"
                scrollButtons="auto">
                {pageTabs.map((item,index)=>{
                    return (<Tab name={index} key={index} label={application.getLocale(item?.label)}></Tab>);
                })}
            </Tabs>
            <TabComponent parentId={rowId} parent={row} application={application} userData={userData} entityType={entityType} pageTabCallback={pageTabCallback} refreshToken={refreshToken}></TabComponent>
        </Box>}
    </>;
}
export default PageDetailTabs;